import React from "react";

// Section headline for the Development Inventory steps — big enough to read as a new section.
export function StepHeading({ step, title, subtitle, testid, children }) {
  return (
    <div className="pt-6 flex items-end justify-between gap-4 flex-wrap" data-testid={testid}>
      <div>
        <div className="text-[10px] uppercase tracking-[0.45em] text-[var(--org-accent)] font-bold">Step {step}</div>
        <h3 className="font-heading uppercase tracking-tight text-white leading-none mt-1 text-2xl md:text-3xl">{title}</h3>
        <div className="mt-2 h-[2px] w-12 bg-[var(--org-accent)]" />
        {subtitle && <div className="mt-2 text-[10px] uppercase tracking-widest text-[#757575]">{subtitle}</div>}
      </div>
      {children}
    </div>
  );
}
